import { safe } from "pb.safe";

export async function checkInternetConnection(): Promise<boolean> {
	const url = "https://sdk.myzeller.com?_=" + Date.now();
	return !(
		(await safe(() =>
			fetch(url, { method: "HEAD", mode: "no-cors" }),
		)) instanceof Error
	);
}
